/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_List_Dir_SuccessInputs */

const es_tools_legajox_list_dir_success = /** @type {(inputs: Tools_Legajox_List_Dir_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpetas de Legajox listadas`)
};

const en_tools_legajox_list_dir_success = /** @type {(inputs: Tools_Legajox_List_Dir_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox folders listed`)
};

/**
* | output |
* | --- |
* | "Legajox folders listed" |
*
* @param {Tools_Legajox_List_Dir_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_list_dir_success = /** @type {((inputs?: Tools_Legajox_List_Dir_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_List_Dir_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_list_dir_success(inputs)
	return en_tools_legajox_list_dir_success(inputs)
});
export { tools_legajox_list_dir_success as "tools.legajox.list_dir_success" }